import classNames from 'classnames';
import Text from '../Text';
import { FC, PropsWithChildren } from 'react';

const commonClasses =
  'text-blue text-left flex items-center border-4 border-transparent \
  underline-offset-8 decoration-current decoration-2';

const focusClasses =
  'focus:outline-none focus-visible:outline-offset-4 \
  focus-visible:outline-4 focus-visible:outline-focus';

const activeClasses = 'active:translate-y-1';

const hoverClasses = 'betterhover:hover:text-grey-800';

type RadioButtonProps = PropsWithChildren<{
  onClick?: () => void;
  className?: string;
  ariaLabel?: string;
  selected?: boolean;
}>;

const RadioButton: FC<RadioButtonProps> = (props) => {
  const { onClick, className, children, ariaLabel, selected } = props;

  const classes = classNames(
    commonClasses,
    focusClasses,
    activeClasses,
    hoverClasses,
    className,
    selected ? 'font-bold' : '',
  );

  return (
    <button className={classes} onClick={onClick} aria-label={ariaLabel}>
      <div className="h-[1em] w-[1em] border-current border-2 rounded-full flex items-center justify-center aspect-square">
        {selected && (
          <div className="h-[6px] w-[6px] rounded-full bg-current aspect-square"></div>
        )}
      </div>
      <Text
        bold={selected}
        elementType="div"
        color="inherit"
        className="leading-none ml-4 flex justify-between flex-1"
        size="label"
      >
        {children}
      </Text>
    </button>
  );
};

export default RadioButton;
